import { Button, makeStyles, Tooltip } from '@fluentui/react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TaxReturnTOCItem } from '../../model';
import { customPalette } from '../../theme';

export interface IFormNavigationProps {
    isFirstForm: boolean;
    isLastForm: boolean;
    onPreviousFormClick: () => void;
    onNextFormClick: () => void;
    currentItem?: TaxReturnTOCItem;
}

const useStyles = makeStyles({
    wrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '5px',
        paddingTop: 0,
        paddingRight: '0.5rem',
        paddingBottom: 0,
        paddingLeft: '0.5rem',
    },
    button: {
        fontSize: '0.75rem',
        height: '1.5rem',
        color: customPalette.grey222222,
    },
});

export const FormNavigation: React.FC<IFormNavigationProps> = ({
    isFirstForm,
    isLastForm,
    onPreviousFormClick,
    onNextFormClick,
    currentItem,
}) => {
    const { t } = useTranslation();
    const styles = useStyles();

    const isStatement = currentItem?.isStatement ?? false;
    const isDiagnostic = currentItem?.isDiagnostic ?? false;

    const previousDocument = t('previousDocument').toString();
    const nextDocument = t('nextDocument').toString();

    let previousFormText = t('previousForm').toString();
    if (isStatement) {
        previousFormText = t('previousStatement').toString();
    }
    if (isDiagnostic) {
        previousFormText = previousDocument;
    }

    let nextFormText = t('nextForm').toString();
    if (isStatement) {
        nextFormText = t('nextStatement').toString();
    }
    if (isDiagnostic) {
        nextFormText = nextDocument;
    }

    return (
        <div className={styles.wrapper}>
            <Tooltip content={previousFormText} relationship='description' appearance='inverted' withArrow positioning='above'>
                <span>
                    <Button
                        appearance='secondary'
                        className={styles.button}
                        aria-label={previousFormText}
                        disabled={isFirstForm}
                        disabledFocusable={isFirstForm}
                        onClick={onPreviousFormClick}
                    >
                        {previousFormText}
                    </Button>
                </span>
            </Tooltip>
            <Tooltip content={nextFormText} relationship='description' appearance='inverted' withArrow positioning='above'>
                <span>
                    <Button
                        appearance='secondary'
                        className={styles.button}
                        aria-label={nextFormText}
                        disabled={isLastForm}
                        disabledFocusable={isLastForm}
                        onClick={onNextFormClick}
                    >
                        {nextFormText}
                    </Button>
                </span>
            </Tooltip>
        </div>
    );
};
